import axios from "axios";
import Config from "../../Config";

const getHeaders = () => ({
  headers: {
    "Content-Type": "application/json",
    Accept: "application/json",
    Authorization: `Bearer ${localStorage.getItem("auth_token")}`,
  },
});

const buildErrorMessage = (error, fallback) =>
  error?.response?.data?.data?.reason ||
  error?.response?.data?.message ||
  error?.message ||
  fallback;

export class PaymentsService {
  static async getPayments(params = {}) {
    try {
      const cleanParams = Object.fromEntries(
        Object.entries(params).filter(([, value]) => value !== undefined && value !== null && value !== "")
      );

      const response = await axios.get(`${Config.baseUrl}/payments`, {
        ...getHeaders(),
        params: cleanParams,
      });

      return { success: true, data: response.data?.data };
    } catch (error) {
      return {
        success: false,
        message: buildErrorMessage(error, "Failed to fetch payments"),
      };
    }
  }

  static async getPaymentDetails(paymentCode) {
    try {
      const response = await axios.get(`${Config.baseUrl}/payments/${paymentCode}`, getHeaders());
      return { success: true, data: response.data?.data };
    } catch (error) {
      return {
        success: false,
        message: buildErrorMessage(error, "Failed to fetch payment details"),
      };
    }
  }
}

export default PaymentsService;
